import {
    postServiceLoading,
    postServiceRequest,
    postServiceSuccess,
    postServiceReject,
    postServiceReset
} from "../../actions/services/post";

export const postService = (formData) => async (dispatch, getState) => {
    dispatch(postServiceLoading());
    try {
        const { data } = await postServiceRequest(formData, getState);
        dispatch(postServiceSuccess(data))
    } catch (error) {
        dispatch(postServiceReject(error))
    } finally {
        setTimeout(() => { dispatch(postServiceReset()) }, 3000);
    }
    return Promise.resolve();
};